import angular from "angular";

import restangular from "./restangular";
import ConfigService from "./ConfigService";

export default angular.module("services.DownloadRA",[restangular,ConfigService])
.factory("DownloadRA",["Restangular","ConfigService",function DownloadRA(Restangular, ConfigService) {
  return Restangular.withConfig(function (RestangularConfigurer) {
    RestangularConfigurer.setBaseUrl(ConfigService.get("urls.dcb-downloads", true));
  });
}]).name;



// WEBPACK FOOTER //
// ./src/ui/app/services/DownloadRA.js